import { graphql } from "react-relay";

export const AddSlackProfileMutation = graphql`
  mutation AddSlackProfileMutation(
    $connections: [ID!]!
    $input: SlackConfigurationInput!
  ) {
    addSlackProfile(input: $input) {
      configuration
        @appendNode(
          connections: $connections
          edgeTypeName: "ConfigurationEdge"
        ) {
        id
        profile
        record {
          ... on SlackConfiguration {
            token
            webhooks {
              name
              url
            }
          }
        }
        scope
      }
    }
  }
`;
